function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m20.86 10.85a3.09 3.09 0 0 0 .14-.85v-4c0-2.85-4.3-5-10-5s-10 2.15-10 5v4a3.89 3.89 0 0 0 2.14 3.16 2.64 2.64 0 0 0 -.14.84v4c0 2.85 4.3 5 10 5s10-2.15 10-5v-4a3.86 3.86 0 0 0 -2.14-3.15zm-9.86 4.15c3.85 0 7.06-1 8.74-2.5.8.48 1.26 1 1.26 1.5 0 1.22-3.12 3-8 3s-7.91-1.73-8-2.95a17.75 17.75 0 0 0 6 .95zm0-12c4.88 0 8 1.78 8 3s-3.12 3-8 3-8-1.78-8-3 3.12-3 8-3zm-8 6.06a14.93 14.93 0 0 0 8 1.94 14.93 14.93 0 0 0 8-1.94v.94c0 1.22-3.12 3-8 3s-8-1.78-8-3zm10 11.94c-4.88 0-8-1.78-8-3v-.94a14.93 14.93 0 0 0 8 1.94 14.93 14.93 0 0 0 8-1.94v.94c0 1.22-3.12 3-8 3z"
});

var SvgCoins = function SvgCoins(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCoins, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/coins.52fe8387.svg";
export { ForwardRef as ReactComponent };